import { render, staticRenderFns } from "./AssetHistory.vue?vue&type=template&id=109afdd6"
import script from "./AssetHistory.vue?vue&type=script&lang=js"
export * from "./AssetHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports